module.exports = __webpack_public_path__ + "static/media/siddharth-ooty-trip-03.26715c2c.png";